import { Collection } from 'firestorter';
import Collections from '../../utils/collections';
import BaseDocument from '../../Model/BaseDocument';

class SmartCheckInReply extends BaseDocument {
  constructor(id, opts) {
    super(`${Collections.SMART_CHECK_IN_REPLY}/${id}`, opts);
  }

  get generatedResponse() {
    return this.data.response || '';
  }

  get checkInId() {
    return this.data.checkInId || '';
  }

  /** The latest draft this coach has for a check-in; each coach drafts their own. */
  static async getLatestByCheckInIdAndCoach(checkInId, coachId) {
    const smartCheckInRepliesCollection = new Collection(Collections.SMART_CHECK_IN_REPLY, {
      createDocument: (src, opts) => new SmartCheckInReply(src.id, { ...opts, disableObserverRefCount: true }),
      query: (ref) => ref
        .where('checkInId', '==', checkInId)
        .where('coach', '==', coachId)
        .orderBy('createdAt', 'desc')
        .limit(1),
    });

    await smartCheckInRepliesCollection.fetch();

    return smartCheckInRepliesCollection;
  }
}

export default SmartCheckInReply;
